import { useState } from 'react';
import Modal from '../Modal/Modal';
import { CustomInformationFieldProps } from './types/CustomInputsTypes';
import DynamicTable from './CustomInformationTable';
import InformationModal from '../Modal/InformationModal';

const CustomInformationField = ({
  label,
  description,
  beforeLinkDescription,
  inlineTriggerText,
  modalContent,
  table_response,
  onFocus,
  className,
  isAdminReview,
}: CustomInformationFieldProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const renderFormattedDescription = () => {
    if (!beforeLinkDescription) return null;

    const knownPrefixes = ['Note:', 'Attention:'];
    const matchedPrefix = knownPrefixes.find((prefix) => beforeLinkDescription.startsWith(prefix));

    if (matchedPrefix) {
      return (
        <>
          <strong>{matchedPrefix}</strong>
          {beforeLinkDescription.slice(matchedPrefix.length)}
        </>
      );
    }

    return beforeLinkDescription;
  };

  return (
    <div
      className={`flex flex-col gap-2 p-4 rounded ${className} ${
        isAdminReview ? 'bg-green-100 border-l-4 border-green-500' : 'bg-yellow-100'
      }`}
    >
      <div className="text-sm text-ds-gray-600">
        {description && <p className="mb-2">{description}</p>}

        {beforeLinkDescription && (
          <p className="legal-note-print">
            <span className="text-ds-orange-900 text-xs">{renderFormattedDescription()}</span>
            <span
              className="text-ds-purple-600 text-xs ml-1 cursor-pointer underline"
              onClick={() => {
                onFocus?.();
                openModal();
              }}
            >
              {inlineTriggerText}
            </span>
          </p>
        )}
      </div>

      {isModalOpen && table_response?.length == 0 && (
        <InformationModal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={label}
          size="xl"
          data={modalContent || ''}
          modalName="info_model"
        />
      )}

      {isModalOpen && table_response?.length > 0 && (
        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={table_response[0]?.label}
          size="xxl"
          modalName="dynamic_table_modal"
        >
          <DynamicTable tableData={table_response[0]} />
        </Modal>
      )}
    </div>
  );
};

export default CustomInformationField;
